import { useEffect } from "react";

// useSupportFabLift — reserve the bottom edge for a page-level fixed bar.
//
// The floating support button (App.js) anchors to the bottom-right corner.
// Pages that pin their own fixed bar to the bottom edge (e.g. My Agency's
// mobile "Invite agent" FAB bar, z-30 over the support button's z-20) parked
// that bar ON TOP of the support button, making it unreachable — and hiding
// the support button is not an option. Call this hook with the height (px)
// the bar occupies and the support button rises by that amount for as long
// as the caller stays mounted; the button's drag/persistence model is
// untouched (the lift is a pure paint offset via a CSS custom property that
// App.js adds inside its `bottom` calc).
//
// Pass 0 (or omit mounting) to leave the button at its resting inset.
// Last-writer-wins if two bars are ever mounted at once — acceptable for
// the current one-bar-per-page reality.
const useSupportFabLift = (px) => {
  useEffect(() => {
    if (!px) return undefined;
    const root = document.documentElement;
    root.style.setProperty("--support-fab-lift", `${px}px`);
    return () => {
      root.style.removeProperty("--support-fab-lift");
    };
  }, [px]);
};

export default useSupportFabLift;
